import { Width620 } from './components/Width620'
import { SideSheet } from './components/SideSheet'

export const Layout = {
  Width620,
  SideSheet
}
